import { render, staticRenderFns } from "./DashboardLayoutV1.vue?vue&type=template&id=035e20b9&scoped=true&"
import script from "./DashboardLayoutV1.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035e20b9",
  null
  
)

export default component.exports